


import vue from 'vue'

import router from 'vue-router'
vue.use(router)



import home from './components/home/home.vue'
import privacy from './components/privacy/privacy.vue'



let appRouter =  new router({
	mode : 'history',
	routes : [
		{
			path : '/',
			components : {
				canvas : home
			}
		},
		{
			path : '/privacy',
			components : {
				canvas : privacy
			}
		},
		{
			path : '*',
			components : {
				canvas : home
			}
		}
	]
})

export default appRouter



// WEBPACK FOOTER //
// ./src/app-router.js